export default "__VITE_ASSET__BVEi2Cs$__"